import { defineMessages } from 'react-intl';

export default defineMessages({
    edit: {
        id: 'ml.gateway.MLRentedTrailerCamperTablePopUP.Edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.gateway.MLRentedTrailerCamperTablePopUP.Remove',
        defaultMessage: 'Remove'
    },
});